module.exports = __webpack_public_path__ + "static/media/FACE.b16d3461.jpg";